import { type ResultOf } from '@graphql-typed-document-node/core'
import { atomWithReset } from 'jotai/utils'

import { graphql } from '~/gql'
import { type OverlapAnalysisPage_TabulationMutationMutationVariables as MutationVariables } from '~/gql/graphql'

export const isTabulationReadyAtom = atomWithReset(false)
export const isPendingTabulationAtom = atomWithReset(false)

const tabulationQueryDataFragment = graphql(`
  fragment OverlapAnalysisPage_TabulationQueryData on CountOverlapAnalysisResult {
    answers {
      ...GroupCountsFigures_QuestionTabulationQueryData
    }
    customerAttributes {
      ...GroupCountsFigures_CustomerAttributeTabulationQueryData
    }
    overlap {
      overlap {
        UNRECOGNIZED_x_UNRECOGNIZED
        UNRECOGNIZED_x_RECOGNIZED
        UNRECOGNIZED_x_ESTRANGED
        UNRECOGNIZED_x_GENERAL
        UNRECOGNIZED_x_LOYAL
        RECOGNIZED_x_UNRECOGNIZED
        RECOGNIZED_x_RECOGNIZED
        RECOGNIZED_x_ESTRANGED
        RECOGNIZED_x_GENERAL
        RECOGNIZED_x_LOYAL
        ESTRANGED_x_UNRECOGNIZED
        ESTRANGED_x_RECOGNIZED
        ESTRANGED_x_ESTRANGED
        ESTRANGED_x_GENERAL
        ESTRANGED_x_LOYAL
        GENERAL_x_UNRECOGNIZED
        GENERAL_x_RECOGNIZED
        GENERAL_x_ESTRANGED
        GENERAL_x_GENERAL
        GENERAL_x_LOYAL
        LOYAL_x_UNRECOGNIZED
        LOYAL_x_RECOGNIZED
        LOYAL_x_ESTRANGED
        LOYAL_x_GENERAL
        LOYAL_x_LOYAL
      }
    }
  }
`)

export const tabulationQueryDataAtom = atomWithReset<ResultOf<
  typeof tabulationQueryDataFragment
> | null>(null)

export const lastTabulatedVariablesAtom =
  atomWithReset<MutationVariables | null>(null)
